import {
  X_MENTION,
  X_POST_LIMIT,
  X_URL_LENGTH,
} from "~/feature/chart/components/XShareDialog/constants";

interface IXPostExtras {
  mention: boolean;
  link: boolean;
  hashtags: string | null;
}

const withSpace = (length: number): number => (length ? 1 + length : 0);

export const getXPostLimit = ({
  mention,
  link,
  hashtags,
}: IXPostExtras): number =>
  X_POST_LIMIT -
  withSpace(mention ? `via ${X_MENTION}`.length : 0) -
  withSpace(link ? X_URL_LENGTH : 0) -
  withSpace(hashtags?.trim().length ?? 0);
